<template>
  <div>
    <div v-if="!['reject', 'accept'].includes(data.status)" v-status="meta.permission_prefix + 'edit'">
      <v-speed-dial v-model="fab" direction="right">
        <template v-slot:activator>
          <v-btn icon>
            <v-icon v-if="fab" color="pink darken-1 icon-xl-2x">mdi-close</v-icon>
            <v-icon v-else class="icon-xl-2x" color="black">mdi-dots-vertical</v-icon>
          </v-btn>
        </template>

        <v-btn class="btn-update btn-sm m-1" fab rounded x-small @click="action(data, 'accept')">
          <v-icon>mdi-thumb-up</v-icon>
        </v-btn>

        <v-btn class="btn-delete btn-sm m-1" fab rounded x-small @click="action(data, 'reject')">
          <v-icon>mdi-thumb-down</v-icon>
        </v-btn>
      </v-speed-dial>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    data: {},
    action: {
      type: Function
    },
    meta: {
      type: Object
    }
  },

  data: () => ({
    fab: false
  })
}
</script>
